import { Card } from 'react-bootstrap';

const WorkspaceCard = (props) => {
  const { title, url } = props;
  const imageUrl =
    'https://images.unsplash.com/photo-1542903660-eedba2cda473?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Card
      onClick={handleClick}
      style={{
        width: '350px',
        height: '240px',

        cursor: 'pointer', // Manual pointer for better UX
        overflow: 'hidden', // Keeps the image corners rounded
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #dcd7b5', // Using your theme color
      }}
      className="shadow-sm hover-shadow" // Bootstrap helper classes
    >
      <Card.Img
        variant="top"
        src={imageUrl}
        style={{ height: '80px', objectFit: 'cover' }}
        alt="workspace header image"
      />
      <Card.Body style={{ paddingTop: '24px' }}>
        <Card.Title
          style={{
            color: '#001642',
            fontSize: '1.25rem',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <strong>{title}</strong>
        </Card.Title>
      </Card.Body>
    </Card>
  );
};
export default WorkspaceCard;
